module.exports = __webpack_public_path__ + "img/my-account.c890c6f0.svg";